// removed by extract-text-webpack-plugin
module.exports = {"svgStyles":"_3iWOCiuBGOTS2ngmYabIZo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SurveyLogo/SurveyLogo.scss
// module id = 2337
// module chunks = 0